// i18n area 'tasks' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da tasks.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/tasks.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './tasks'

export const ptBR: DeepPartial<typeof enUS> = {
  // Sistema > Audit (#328): il portoghese europeo scrive 'registo' e 'aceite',
  // il brasiliano 'registro' e 'aceito' — è la stessa famiglia lessicale già
  // dichiarata nell'intestazione. Tutto il resto del blocco è identico e resta
  // ereditato da pt-PT.
  audit: {
    loadError: 'Não foi possível carregar o registro de auditoria — o backend TVirt está acessível?',
    subtitle: 'Quem fez o quê, quando e sobre qual objeto — atos tentados, recusas incluídas',
    empty: 'Nenhum ato registrado',
    detailId: 'ID do registro',
    taskHint: 'O resultado de um ato aceito vive no diário de eventos, sob este mesmo id de task',
    outcome: {
      accepted: 'Aceito',
      failed: 'Falhou'
    }
  }
}
